import { ComputedRef, Ref, watch } from 'vue';

/**
 * Seeds a settings-tab form from an async store source. The first arrival always seeds (before it,
 * the empty form reads as "dirty" against the loaded value); later store refreshes reseed only when
 * the user isn't mid-edit, so a background refresh never clobbers unsaved changes.
 *
 * `reset` and `isDirty` are the same pair each tab exposes to the profile shell's discard guard,
 * so a tab wires this in one line instead of re-deriving the (subtle) seed-once rule.
 */
export function useSeededForm(source: Ref<unknown>, reset: () => void, isDirty: ComputedRef<boolean>): void {
  let hasSeeded = false;

  watch(
    source,
    (loaded) => {
      if (!loaded) return;

      if (!hasSeeded || !isDirty.value) {
        reset();
        hasSeeded = true;
      }
    },
    { immediate: true },
  );
}
